<div *ngIf="hasLoaded" class="full-height">
  <google-map
    id="map"
    height="100%"
    width="100%"
    [center]="marker"
    [zoom]="zoom"
    [options]="options"
    (mapClick)="onMapClick($event)"
    (tilesloaded)="onMapReady()">
    <ion-button
      *ngIf="!isRoadAssistTracing"
      id="gps"
      (click)="getLocation()"
      color="smooth-dark"
      class="gps-button position-b-l"
    >
      <img src="assets/images/gps.svg" alt="Gps logo"/>
    </ion-button>
    <map-marker
      *ngIf="!isRoadAssistTracing"
      [position]="marker"
      [options]="optionsMarker"
      (mapDragend)="onMarkerDragEnd($event)"
    >
    </map-marker>
    <div *ngIf="!uniqueMarker && multipleMarkers?.length > 0">
      <map-marker
        *ngFor="let marker of multipleMarkers; let i = index"
        [position]="marker"
        [options]="{icon: marker.icon}"
        (mapClick)="onMarkerClicked(marker, i)"
      >
        <map-info-window id="info-window">
          <div
            class="info-window-custom pwa-map"
            *ngIf="marker?.service?.infoWindowTemplateEntries"
          >
            <div
              *ngFor="let entry of marker.service.infoWindowTemplateEntries"
              (click)="onInfoWidowEntryClick(marker.service, entry.id)"
            >
              <div class="header" *ngIf="entry.type === 'header'">
                {{ entry.text }}
              </div>
              <div class="text" *ngIf="entry.type === 'text'">
                {{ entry.text }}
              </div>
              <div class="icon-text" *ngIf="entry.type === 'icon-text'">
                <img class="icon" src="{{ entry.iconUrl }}" />
                <a class="text">
                  {{ entry.text }}
                </a>
              </div>
              <div class="icon-ref" *ngIf="entry.type === 'icon-ref'">
                <img class="icon" src="{{ entry.iconUrl }}" alt="seervice-icon" />
                <a class="text" href="{{ entry.href }}">
                  {{ entry.text }}
                </a>
              </div>
              <div class="button" *ngIf="entry.type === 'button'">
                <ion-button color="primary">
                  {{ entry.text }}
                </ion-button>
              </div>
            </div>
          </div>
        </map-info-window>
      </map-marker>
    </div>
  </google-map>
</div>